(function ($) {

    /* COLLAPSE PUBLIC CLASS DEFINITION
    * ================================ */

    var TsCollapse = function (element, options) {
        this.$element = $(element)
        this.options = $.extend({}, $.fn.ts_collapse.defaults, options)

        if (this.options.parent) {
            this.$parent = $(this.options.parent);
        }

        this.options.toggle && this.toggle();
    }

    TsCollapse.prototype = {

        constructor: TsCollapse,

        dimension: function () {
            var hasWidth = this.$element.hasClass('width')
            return hasWidth ? 'width' : 'height'
        },

        show: function () {
            var dimension, scroll, actives, hasData;

            if (this.transitioning || this.$element.hasClass('in'))
                return;

            dimension = this.dimension();
            scroll = $.camelCase(['scroll', dimension].join('-'));
            actives = this.$parent && this.$parent.find('> .accordion-group > .in');

            if (actives && actives.length) {
                hasData = actives.data('collapse');
                if (hasData && hasData.transitioning) return
                actives.ts_collapse('hide');
                hasData || actives.data('collapse', null);
            }

            this.$element[dimension](0);
            if (this.$element.children().children().children().length > 0) {
                this.transition('addClass', $.Event('show'), 'shown');
                $.support.transition && this.$element[dimension](this.$element[0][scroll]);
            }


            var $this = this.$element, $ul = $this.closest('ul:not(.dropdown-menu)'), selector = $this.attr('data-tab'), previous, $target, e;
            if (!selector) {
                selector = this.options.tab; //$this.attr('data-tab')
                selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
            }
            if ($this.parent('li').hasClass('active')) return
            previous = $ul.find('.active:last a')[0]
            e = $.Event('show', {
                relatedTarget: previous
            })
            $this.trigger(e)
            if (e.isDefaultPrevented()) return
            $target = $(selector)
            this.activate($this.parent('li'), $ul)
            this.activate($target, $target.parent(), function () {
                $this.trigger({
                    type: 'shown',
                    relatedTarget: previous
                })
            })

        },

        hide: function () {
            var dimension
            if (this.transitioning || !this.$element.hasClass('in'))
                return;

            dimension = this.dimension();
            this.reset(this.$element[dimension]());
            this.transition('removeClass', $.Event('hide'), 'hidden');
            this.$element[dimension](0);
        },

        reset: function (size) {
            var dimension = this.dimension()

            this.$element
				.removeClass('collapse')
				[dimension](size || 'auto')
				[0].offsetWidth

            this.$element[size !== null ? 'addClass' : 'removeClass']('collapse');

            return this
        },

        transition: function (method, startEvent, completeEvent) {
            var that = this
			, complete = function () {
			    if (startEvent.type == 'show') that.reset()
			    that.transitioning = 0
			    that.$element.trigger(completeEvent)
			}

            this.$element.trigger(startEvent)

            if (startEvent.isDefaultPrevented()) return

            this.transitioning = 1

            this.$element[method]('in')

            $.support.transition && this.$element.hasClass('collapse') ?
			this.$element.one($.support.transition.end, complete) :
			complete()
        },

        activate: function (element, container, callback) {
            var $active = container.find('> .active')
		   , transition = callback
			   && $.support.transition
			   && $active.hasClass('fade')

            function next() {
                $active
			 .removeClass('active')
			 .find('> .dropdown-menu > .active')
			 .removeClass('active')

                element.addClass('active')

                if (transition) {
                    element[0].offsetWidth // reflow for transition
                    element.addClass('in')
                } else {
                    element.removeClass('fade')
                }

                if (element.parent('.dropdown-menu')) {
                    element.closest('li.dropdown').addClass('active')
                }

                callback && callback()
            };

            transition ?
		   $active.one($.support.transition.end, next) :
		   next()

            $active.removeClass('in')
        },

        toggle: function () {
            this[this.$element.hasClass('in') ? 'hide' : 'show']()
        }

    }

    /* COLLAPSE PLUGIN DEFINITION
    * ========================== */

    var old = $.fn.collapse

    $.fn.ts_collapse = function (option) {
        return this.each(function () {
            var $this = $(this),
            data = $this.data('collapse'),
            options = $.extend({}, $.fn.ts_collapse.defaults, $this.data(), typeof option == 'object' && option);

            if (!data)
                $this.data('collapse', (data = new TsCollapse(this, options)));
            if (typeof option == 'string')
                data[option]()
        })
    }

    $.fn.ts_collapse.defaults = {
        toggle: true
    };

    $.fn.ts_collapse.Constructor = TsCollapse;

    /* COLLAPSE NO CONFLICT
    * ==================== */

    $.fn.collapse.noConflict = function () {
        $.fn.collapse = old
        return this
    }
    /* COLLAPSE DATA-API
    * ================= */
    $(document).on('click.ts-collapse.data-api', '[data-toggle=ts-collapse]', function (e) {
        var $this = $(this), href,
            target = $this.attr('data-target')
            || e.preventDefault()
            || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''), //strip for ie7
            option = $(target).data('collapse') ? 'toggle' : $this.data();

        $this[$(target).hasClass('in') ? 'addClass' : 'removeClass']('collapsed');
        $(target).ts_collapse(option);
    })

} (jQuery));
